import { TabSales } from 'utils/tabSales';
import { TabRestaurantLite } from 'utils/tabRestaurant';
import { TabRestaurantPro } from 'utils/tabRestaurantPro';

const initialState = {
  tabSales: TabSales,
  tabRestaurantPro: TabRestaurantPro,
  tabRestaurantLite: TabRestaurantLite,
  tabActive: 0,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_TAB_MENU_SALES':
      return { ...state, tabSales: action.payload };
    case 'SET_MENU_RESTAURANT_PRO':
      return { ...state, tabRestaurantPro: action.payload };
    case 'SET_MENU_RESTAURANT_LITE':
      return { ...state, tabRestaurantLite: action.payload };
    case 'SET_ACTIVE_TAB':
      return { ...state, tabActive: action.payload };
    default:
      return state;
  }
}
